/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/ConfirmWaitScreen.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import '../../../static/images/loading2.gif';

const bookCreationInProgress = (context) => (
  <div className="waiting-confirmation">
    <div className="message">
      <div><b>{context.t('Your booking is being confirmed')}</b></div>
      <img src="/img/loading2.gif" />{context.t('Please wait while we confirm your booking')}
    </div>
  </div>
);

const bookCreationError = (props, context) => (
  <div className="waiting-confirmation">
    <div className="message has-error">
      <div><b><i className="fa fa-exclamation-triangle" />{context.t('Sorry, your booking could not be confirmed')}</b></div>
      {context.t('If the problem persists, please take a screenshot and contact the hotel.')}
    </div>
    <div className="message">
      {props.isFreeModeSelected ? props.confirmErrorState : ''}
    </div>
  </div>
);

const jumpToTPV = (context) => (
  <div className="show-tpv">
    <p>
      {context.t('One moment, please. You are being redirected to the chosen payment page.')}
      <img src="/img/loading2.gif"/>
    </p>
  </div>
);

const ConfirmWaitScreen = (props, context) => {
  const { mode } = props;
  switch (mode) {
    case 'tpv':
      return jumpToTPV(context);
    case 'error':
      return bookCreationError(props, context);
    default:
      return bookCreationInProgress(context);
  }
};

ConfirmWaitScreen.propTypes = {
  mode: PropTypes.oneOf(['tpv', 'error', 'waiting']),
};

ConfirmWaitScreen.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  confirmErrorState: state.booking.confirmErrorState,
});

export default connect(mapStateToProps)(ConfirmWaitScreen);
